import React from 'react';
import { Printer, CalendarIcon, PercentIcon, ScanIcon, CheckIcon, MapPinIcon, UsersIcon, GemIcon, HeartIcon, ShieldCheckIcon, PhoneIcon, Instagram, MessageCircleIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
const SERIF = "'Playfair Display', serif";
const SCRIPT = "'Caveat', cursive";
const GOLD = '#c9a96a';
const GOLD_DARK = '#b08e4f';
const CREAM = '#f5efe5';
const CREAM_LIGHT = '#faf5ec';
const CHARCOAL = '#1f1f1f';
const exact = {
  WebkitPrintColorAdjust: 'exact',
  printColorAdjust: 'exact'
} as React.CSSProperties;
export function OrthodonticFlyerUaPage() {
  const handlePrint = () => window.print();
  return <div className="min-h-screen bg-gray-100 p-6 print:p-0 print:bg-white" data-id="element-2108">
      {/* Controls */}
      <div className="no-print max-w-[210mm] mx-auto mb-6 flex items-center justify-between" data-id="element-2109">
        <div data-id="element-2110">
          <h1 className="text-xl font-bold text-gray-900" data-id="element-2111">
            Dentico Clinic — Орто Флаєр (Українською)
          </h1>
          <p className="text-sm text-gray-500 mt-0.5" data-id="element-2112">
            A4 vertical · Tip: enable <strong data-id="element-2113">Background graphics</strong> in
            print settings.
          </p>
        </div>
        <Button onClick={handlePrint} className="gap-2 shadow-md" data-id="element-2114">
          <Printer className="w-4 h-4" data-id="element-2115" />
          Print Flyer
        </Button>
      </div>

      {/* A4 Page */}
      <div className="flyer-page mx-auto shadow-2xl print:shadow-none relative overflow-hidden" style={{
      width: '210mm',
      height: '297mm',
      backgroundColor: CREAM_LIGHT,
      ...exact
    }} data-id="element-2116">
        {/* === HERO PORTRAIT — bleeds top-right, full height to ~64% === */}
        <div className="absolute top-0 right-0" style={{
        width: '52%',
        height: '64%',
        zIndex: 1,
        ...exact
      }} data-id="element-2117">
          <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1400&q=85" alt="Smiling woman" className="w-full h-full object-cover" style={{
          objectPosition: 'center 25%',
          ...exact
        }} data-id="element-2118" />
          {/* Soft fade into cream on left edge */}
          <div className="absolute inset-y-0 left-0 w-2/5" style={{
          background: `linear-gradient(to right, ${CREAM_LIGHT} 0%, rgba(250,245,236,0.5) 30%, rgba(250,245,236,0) 100%)`,
          ...exact
        }} data-id="element-2119" />
          {/* Soft fade into cream on bottom */}
          <div className="absolute inset-x-0 bottom-0 h-1/4" style={{
          background: `linear-gradient(to top, ${CREAM_LIGHT} 0%, rgba(250,245,236,0) 100%)`,
          ...exact
        }} data-id="element-2120" />
        </div>

        {/* === LOGO TOP === */}
        <div className="absolute top-0 left-0 flex items-center gap-3 pl-10 pt-9" style={{
        zIndex: 10
      }} data-id="element-2121">
          <div className="rounded-full flex items-center justify-center" style={{
          width: '54px',
          height: '54px',
          border: `1.5px solid ${GOLD}`,
          ...exact
        }} data-id="element-2122">
            <img src="https://cdn.magicpatterns.com/uploads/oHJPxkkc7f6GgU5uyo3LQX/ChatGPT_Image_Feb_5,_2026,_03_12_40_PM.png" alt="Dentico" className="w-7 h-7 object-contain" data-id="element-2123" />
          </div>
          <div data-id="element-2124">
            <div className="leading-none" style={{
            fontFamily: SERIF,
            fontWeight: 600,
            fontSize: '36px',
            color: CHARCOAL,
            letterSpacing: '0.06em'
          }} data-id="element-2125">
              DENTICO
            </div>
            <div className="mt-1.5" style={{
            fontSize: '8.5px',
            color: '#7a7060',
            letterSpacing: '0.3em',
            fontWeight: 500
          }} data-id="element-2126">
              DENTAL & AESTHETIC CLINIC
            </div>
          </div>
        </div>

        {/* === HEADLINE LEFT === */}
        <div className="absolute" style={{
        top: '110px',
        left: '40px',
        width: '105mm',
        zIndex: 5
      }} data-id="element-2127">
          <h1 style={{
          fontFamily: SERIF,
          fontWeight: 800,
          fontSize: '64px',
          lineHeight: 0.95,
          color: CHARCOAL,
          letterSpacing: '-0.015em'
        }} data-id="element-2128">
            РІВНІ
            <br data-id="element-2129" />
            ЗУБИ.
          </h1>
          <h1 className="mt-3" style={{
          fontFamily: SERIF,
          fontWeight: 700,
          fontStyle: 'italic',
          fontSize: '52px',
          lineHeight: 1.0,
          color: GOLD_DARK,
          letterSpacing: '-0.01em',
          ...exact
        }} data-id="element-2130">
            Впевнена
            <br data-id="element-2131" />
            посмішка.
          </h1>

          {/* Gold divider */}
          <div className="mt-7 mb-4" style={{
          width: '52px',
          height: '2px',
          backgroundColor: GOLD,
          ...exact
        }} data-id="element-2132" />

          <p style={{
          fontSize: '15px',
          color: '#3f3a32',
          lineHeight: 1.55,
          maxWidth: '88mm'
        }} data-id="element-2133">
            Сучасне ортодонтичне лікування для дітей та дорослих{' '}
            <span style={{
            color: GOLD_DARK,
            fontWeight: 600
          }} data-id="element-2134">
              у Лондоні
            </span>
            .
          </p>
        </div>

        {/* === 0% FINANCE BADGE — circular, floating over portrait === */}
        <div className="absolute rounded-full flex flex-col items-center justify-center text-center" style={{
        top: '128mm',
        right: '14mm',
        width: '40mm',
        height: '40mm',
        backgroundColor: GOLD,
        color: '#ffffff',
        zIndex: 6,
        boxShadow: '0 10px 28px rgba(201,169,106,0.45)',
        ...exact
      }} data-id="element-2135">
          <div className="uppercase leading-tight" style={{
          fontSize: '8px',
          letterSpacing: '0.2em',
          fontWeight: 600
        }} data-id="element-2136">
            Фінансування
            <br data-id="element-2137" />
            доступне
          </div>
          <div className="leading-none my-1" style={{
          fontFamily: SERIF,
          fontSize: '44px',
          fontWeight: 800
        }} data-id="element-2138">
            0%
          </div>
          <div className="uppercase" style={{
          fontSize: '9px',
          letterSpacing: '0.28em',
          fontWeight: 600
        }} data-id="element-2139">
            ВІДСОТКІВ*
          </div>
        </div>

        {/* === FEATURE BLOCKS CARD === */}
        <div className="absolute" style={{
        top: '170mm',
        left: '12mm',
        width: '130mm',
        zIndex: 5
      }} data-id="element-2140">
          <div className="rounded-2xl px-3 py-5" style={{
          backgroundColor: '#ffffff',
          boxShadow: '0 6px 24px rgba(0,0,0,0.05)',
          ...exact
        }} data-id="element-2141">
            <div className="grid grid-cols-3" data-id="element-2142">
              {[{
              Icon: CalendarIcon,
              title: 'БЕЗКОШТОВНА',
              title2: 'КОНСУЛЬТАЦІЯ',
              desc: 'План лікування\nта огляд'
            }, {
              Icon: PercentIcon,
              title: '0%',
              title2: 'ФІНАНСУВАННЯ',
              desc: 'Зручна оплата\nчастинами'
            }, {
              Icon: ScanIcon,
              title: '3D ЦИФРОВЕ',
              title2: 'СКАНУВАННЯ',
              desc: 'Без старих\nвідбитків'
            }].map((f, i) => <div key={i} className="flex flex-col items-center text-center px-2" style={{
              borderRight: i < 2 ? '1px solid #ece4d3' : 'none',
              ...exact
            }} data-id="element-2143">
                  <f.Icon className="mb-3" style={{
                color: GOLD,
                width: 30,
                height: 30,
                ...exact
              }} strokeWidth={1.3} data-id="element-2144" />
                  <div className="uppercase" style={{
                fontSize: '10.5px',
                color: CHARCOAL,
                letterSpacing: '0.16em',
                fontWeight: 700,
                lineHeight: 1.3
              }} data-id="element-2145">
                    {f.title}
                    <br data-id="element-2146" />
                    {f.title2}
                  </div>
                  <div className="mt-2 whitespace-pre-line leading-snug" style={{
                fontSize: '10.5px',
                color: '#6b6253'
              }} data-id="element-2147">
                    {f.desc}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* === SECTION DIVIDER === */}
        <div className="absolute flex items-center gap-4" style={{
        top: '203mm',
        left: '12mm',
        right: '12mm',
        zIndex: 5
      }} data-id="element-2148">
          <div className="flex-1 h-px" style={{
          backgroundColor: '#d9c9a3',
          ...exact
        }} data-id="element-2149" />
          <span className="uppercase whitespace-nowrap" style={{
          fontSize: '10px',
          color: '#7a6a4a',
          letterSpacing: '0.32em',
          fontWeight: 600
        }} data-id="element-2150">
            Оберіть зручний варіант лікування
          </span>
          <div className="flex-1 h-px" style={{
          backgroundColor: '#d9c9a3',
          ...exact
        }} data-id="element-2151" />
        </div>

        {/* === ORTHODONTIC OPTIONS === */}
        <div className="absolute grid grid-cols-3 gap-3" style={{
        top: '210mm',
        left: '12mm',
        right: '12mm',
        zIndex: 5
      }} data-id="element-2152">
          {[{
          img: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?auto=format&fit=crop&w=600&q=80',
          title: 'INVISALIGN®',
          desc: 'Прозорі елайнери для\nкомфортного лікування',
          tags: 'Непомітно · Комфортно · Знімні'
        }, {
          img: 'https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&w=600&q=80',
          title: 'МЕТАЛЕВІ БРЕКЕТИ',
          desc: 'Надійне та ефективне\nвирівнювання',
          tags: 'Надійно · Ефективно · Доступно'
        }, {
          img: 'https://images.unsplash.com/photo-1559591937-abc3a5fab90b?auto=format&fit=crop&w=600&q=80',
          title: 'КЕРАМІЧНІ БРЕКЕТИ',
          desc: 'Більш естетичний та\nнепомітний варіант',
          tags: 'Естетично · Непомітно · Впевнено'
        }].map((o, i) => <div key={i} className="rounded-xl overflow-hidden bg-white" style={{
          boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
          ...exact
        }} data-id="element-2153">
              <img src={o.img} alt={o.title} className="w-full object-cover" style={{
            height: '32mm',
            ...exact
          }} data-id="element-2154" />
              <div className="px-3 pt-3 pb-2.5 text-center" data-id="element-2155">
                <div style={{
              fontFamily: SERIF,
              fontSize: '14px',
              fontWeight: 700,
              color: CHARCOAL,
              letterSpacing: '0.06em'
            }} data-id="element-2156">
                  {o.title}
                </div>
                <div className="mt-1.5 whitespace-pre-line leading-snug" style={{
              fontSize: '10.5px',
              color: '#6b6253'
            }} data-id="element-2157">
                  {o.desc}
                </div>
              </div>
              <div className="flex items-center justify-center gap-1.5 py-1.5" style={{
            backgroundColor: GOLD,
            ...exact
          }} data-id="element-2158">
                <CheckIcon className="w-3 h-3" strokeWidth={2.5} style={{
              color: '#fff',
              ...exact
            }} data-id="element-2159" />
                <span style={{
              fontSize: '9px',
              color: '#fff',
              letterSpacing: '0.08em',
              fontWeight: 600
            }} data-id="element-2160">
                  {o.tags}
                </span>
              </div>
            </div>)}
        </div>

        {/* === CTA BAR === */}
        <div className="absolute flex items-center px-9" style={{
        top: '256mm',
        left: 0,
        right: 0,
        height: '22mm',
        backgroundColor: CHARCOAL,
        zIndex: 5,
        ...exact
      }} data-id="element-2161">
          <div className="rounded-lg flex items-center justify-center flex-shrink-0" style={{
          width: '50px',
          height: '50px',
          backgroundColor: GOLD,
          ...exact
        }} data-id="element-2162">
            <MessageCircleIcon className="w-6 h-6" strokeWidth={1.8} style={{
            color: '#fff',
            ...exact
          }} data-id="element-2163" />
          </div>
          <div className="ml-4 flex-1" data-id="element-2164">
            <div className="uppercase" style={{
            fontSize: '14px',
            color: '#fff',
            fontWeight: 700,
            letterSpacing: '0.06em'
          }} data-id="element-2165">
              Запишіться на{' '}
              <span style={{
              color: GOLD,
              ...exact
            }} data-id="element-2166">
                консультацію
              </span>{' '}
              сьогодні!
            </div>
            <div className="mt-1" style={{
            fontSize: '11px',
            color: '#bdb6a8'
          }} data-id="element-2167">
              Напишіть нам у WhatsApp або зателефонуйте — ми чекаємо на вас.
            </div>
          </div>

          {/* Hand-drawn arrow */}
          <svg width="50" height="26" viewBox="0 0 50 26" className="flex-shrink-0 mr-2" style={exact} data-id="element-2168">
            <path d="M2 18 Q 18 4, 42 10" fill="none" stroke={GOLD} strokeWidth="1.5" strokeLinecap="round" data-id="element-2169" />
            <path d="M37 6 L 43 10 L 38 15" fill="none" stroke={GOLD} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-2170" />
          </svg>

          {/* QR */}
          <div className="flex-shrink-0" style={{
          width: '60px',
          height: '60px',
          backgroundColor: '#fff',
          padding: '4px',
          borderRadius: '4px',
          ...exact
        }} data-id="element-2171">
            <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://wa.me/447371989898&format=png&color=1f1f1f&bgcolor=ffffff" alt="QR" className="w-full h-full object-contain" style={exact} data-id="element-2172" />
          </div>

          <div className="ml-3 flex-shrink-0" style={{
          fontFamily: SCRIPT,
          fontSize: '20px',
          color: GOLD,
          lineHeight: 1.05,
          ...exact
        }} data-id="element-2173">
            Скануй
            <br data-id="element-2174" />
            та запишись!
          </div>
        </div>

        {/* === BOTTOM INFO ROW === */}
        <div className="absolute grid grid-cols-5" style={{
        top: '278mm',
        left: 0,
        right: 0,
        height: '13mm',
        backgroundColor: CREAM,
        zIndex: 5,
        ...exact
      }} data-id="element-2175">
          {[{
          Icon: MapPinIcon,
          title: 'ANGEL, LONDON',
          desc: '62 Blythe Road, W14 0HB'
        }, {
          Icon: UsersIcon,
          title: 'УКРАЇНОМОВНА',
          desc: 'Ваша рідна мова 🇺🇦'
        }, {
          Icon: ShieldCheckIcon,
          title: 'ДОСВІДЧЕНІ ЛІКАРІ',
          desc: 'Лікування на найвищому рівні'
        }, {
          Icon: GemIcon,
          title: 'СУЧАСНА ТЕХНІКА',
          desc: 'Цифрова стоматологія'
        }, {
          Icon: HeartIcon,
          title: 'ВАША ПОСМІШКА',
          desc: 'Наш пріоритет'
        }].map((b, i) => <div key={i} className="flex items-center gap-2 px-2.5" style={{
          borderRight: i < 4 ? '1px solid #e0d4ba' : 'none',
          ...exact
        }} data-id="element-2176">
              <b.Icon className="flex-shrink-0" style={{
            color: GOLD,
            width: 18,
            height: 18,
            ...exact
          }} strokeWidth={1.4} data-id="element-2177" />
              <div className="leading-tight" data-id="element-2178">
                <div className="uppercase" style={{
              fontSize: '7.5px',
              color: CHARCOAL,
              fontWeight: 700,
              letterSpacing: '0.13em',
              lineHeight: 1.2
            }} data-id="element-2179">
                  {b.title}
                </div>
                <div className="mt-0.5" style={{
              fontSize: '7.5px',
              color: '#6b6253',
              lineHeight: 1.3
            }} data-id="element-2180">
                  {b.desc}
                </div>
              </div>
            </div>)}
        </div>

        {/* === FOOTER STRIP === */}
        <div className="absolute flex items-center justify-between px-9" style={{
        top: '291mm',
        left: 0,
        right: 0,
        height: '6mm',
        backgroundColor: CHARCOAL,
        zIndex: 5,
        ...exact
      }} data-id="element-2181">
          <div className="flex items-center gap-2" data-id="element-2182">
            <div className="rounded-full flex items-center justify-center" style={{
            width: '20px',
            height: '20px',
            border: `1px solid ${GOLD}`,
            ...exact
          }} data-id="element-2183">
              <img src="https://cdn.magicpatterns.com/uploads/oHJPxkkc7f6GgU5uyo3LQX/ChatGPT_Image_Feb_5,_2026,_03_12_40_PM.png" alt="" className="w-3 h-3 object-contain" style={{
              filter: 'brightness(0) invert(1)',
              ...exact
            }} data-id="element-2184" />
            </div>
            <span style={{
            fontFamily: SERIF,
            fontSize: '12px',
            color: '#fff',
            fontWeight: 600,
            letterSpacing: '0.12em'
          }} data-id="element-2185">
              DENTICO
            </span>
          </div>

          <div className="flex items-center gap-4" data-id="element-2186">
            <div className="flex items-center gap-1.5" data-id="element-2187">
              <PhoneIcon className="w-3 h-3" strokeWidth={1.6} style={{
              color: GOLD,
              ...exact
            }} data-id="element-2188" />
              <span style={{
              fontSize: '10px',
              color: '#fff'
            }} data-id="element-2189">
                020 4587 6664
              </span>
            </div>
            <div style={{
            width: 1,
            height: 11,
            backgroundColor: '#3a3a3a',
            ...exact
          }} data-id="element-2190" />
            <div className="flex items-center gap-1.5" data-id="element-2191">
              <MessageCircleIcon className="w-3 h-3" strokeWidth={1.6} style={{
              color: GOLD,
              ...exact
            }} data-id="element-2192" />
              <span style={{
              fontSize: '10px',
              color: '#fff'
            }} data-id="element-2193">
                0737 198 9898
              </span>
            </div>
            <div style={{
            width: 1,
            height: 11,
            backgroundColor: '#3a3a3a',
            ...exact
          }} data-id="element-2194" />
            <div className="flex items-center gap-1.5" data-id="element-2195">
              <Instagram className="w-3 h-3" strokeWidth={1.6} style={{
              color: GOLD,
              ...exact
            }} data-id="element-2196" />
              <span style={{
              fontSize: '10px',
              color: '#fff'
            }} data-id="element-2197">
                @dentico.london
              </span>
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-2198">{`
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
          }
          html, body {
            margin: 0;
            padding: 0;
            background: white;
          }
          .no-print {
            display: none !important;
          }
          .flyer-page {
            width: 210mm !important;
            height: 297mm !important;
            box-shadow: none !important;
            margin: 0 !important;
            overflow: hidden !important;
          }
        }
      `}</style>
    </div>;
}